// extracted by mini-css-extract-plugin
export default {"button":"FinanceActivationAdd_button__+7ZMn","icon":"FinanceActivationAdd_icon__mg7de"};